"use client";
import * as React from "react";
const SvgEventNoteFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.89 7.2H3.1v1.6h7.78zm1.55-5.6h-.77V0H10.1v1.6H3.89V0H2.33v1.6h-.77C.69 1.6 0 2.32 0 3.2v11.2c0 .88.7 1.6 1.56 1.6h10.88c.86 0 1.56-.72 1.56-1.6V3.2c0-.88-.7-1.6-1.56-1.6m0 12.8H1.56V5.6h10.88zm-3.88-4H3.1V12h5.45z" }));
export {
  SvgEventNoteFilled as default
};
